export const chips: number[] = [1, 10, 25, 50, 100, 500, 1000, 2500, 5000, 10000, 25000, 50000];
